import * as v from "valibot";

// 节点标签（后端文档：Key 必填 / Value 选填）
export const LabelSchema = v.object({
  Key: v.string(),
  Value: v.optional(v.string()),
});
export type Label = v.InferOutput<typeof LabelSchema>;

// 节点污点（Effect 必填：PreferNoSchedule / NoSchedule / NoExecute）
export const TaintSchema = v.object({
  Key: v.string(),
  Value: v.optional(v.string()),
  Effect: v.string(),
});
export type Taint = v.InferOutput<typeof TaintSchema>;

// 登录方式：Password / SSHKeyId / 二者同时（UI "密钥和密码"模式，EPC）。
// 后端文档称"二选一"，但实际接受同时设置——语义为两个独立可选字段，
// "至少有一个"由 UI 表单层（LoginForm loginMode required）保证，不在 schema 强制。
// UserName 选填（UI 未采集，固定 root/ubuntu 由后端按镜像决定）。
export const LoginSettingSchema = v.object({
  UserName: v.optional(v.string()),
  Password: v.optional(v.string()),
  SSHKeyId: v.optional(v.string()),
});
export type LoginSetting = v.InferOutput<typeof LoginSettingSchema>;

// 容器运行时配置（后端必填，子字段皆选填；Runtime 默认 Containerd）
export const ContainerSchema = v.object({
  Runtime: v.optional(v.string()),
  Path: v.optional(v.string()),
  LogMaxSize: v.optional(v.number()),
  LogMaxFiles: v.optional(v.number()),
});
export type Container = v.InferOutput<typeof ContainerSchema>;

// request — ReinstallNodes（POST, Action=ReinstallNodes, Version 2023-01-01）
// 批量+单节点同接口（单节点传 [id]）。InstanceIds 为 KEC/EPC 实例 ID
// （= BasicSetting.InstanceId，非 MachineId）。关机+重装由后端单接口原子封装。
//
// 独立节点场景前端传完整参数；节点池内节点场景前端仅传 InstanceIds，
// ImageID/LoginSetting/Container 由后端从节点池模板自取，故三者均 optional。
export const RequestSchema = v.object({
  InstanceIds: v.array(v.string()),
  ImageID: v.optional(v.string()),
  PreUserScript: v.optional(v.string()),
  PostUserScript: v.optional(v.string()),
  Labels: v.optional(v.array(LabelSchema)),
  Taints: v.optional(v.array(TaintSchema)),
  LoginSetting: v.optional(LoginSettingSchema),
  Container: v.optional(ContainerSchema),
  // EPC GPU 节点重装时安装的 CUDA 驱动 ID（`${version}_${driver}`）；
  // 仅前端勾选「自动安装 CUDA 驱动」且版本/驱动均非空时传，KEC/节点池场景不传。
  GpuImageDriverId: v.optional(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response — 同步返回每节点受理结果（Return:false 为部分受理失败，
// 前端不单独处理：抽屉已关闭，失败靠表格 ReinstallFailed 状态展示）
export const InstanceSetItemSchema = v.object({
  MachineId: v.optional(v.string()),
  KceNodeId: v.optional(v.string()),
  InstanceId: v.optional(v.string()),
  Return: v.boolean(),
});
export type InstanceSetItem = v.InferOutput<typeof InstanceSetItemSchema>;

export const DataSchema = v.object({
  InstanceSet: v.optional(v.array(InstanceSetItemSchema)),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  RequestId: v.string(),
  Data: v.optional(DataSchema),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
